<template>
  <f7-page
    hide-navbar-on-scroll
    ptr
    :ptr-mousewheel="true"
    @ptr:refresh="loadMore()"
    @page:init="pageInit()"
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMoreScroll()"
  >
    <f7-navbar
      sliding
      no-shadow
      large
      back-link
      :title="$t('common.notification')"
      :back-link-show-text="false"
    >
     <AppLayout  v-if="isTablet">
          <template #main>
      <f7-subnavbar :inner="false"

      >
        <f7-searchbar   v-if="notificationList && notificationList.length > 10"
          class="searchbar-notifications"
          search-container=".notifications-list"
          :backdrop="false"
          :placeholder="$t('common.search')"
          search-in=".item-title, .item-after, .item-subtitle, item-header, .item-text"
        >
        </f7-searchbar>
      </f7-subnavbar>
          </template>
          </AppLayout>
      <f7-nav-right>
      <f7-link v-if="!isTablet"
          class="searchbar-enable"
          data-searchbar=".searchbar-notifications2"
          icon-ios="f7:search"
          icon-md="material:search"
        />
        <navbarright></navbarright>
      </f7-nav-right>
      <f7-searchbar   v-if="notificationList && notificationList.length > 10 &&!isTablet"
          class="searchbar-notifications2"
          search-container=".notifications-list"
          :backdrop="false"
          expandable
          :placeholder="$t('common.search')"
          search-in=".item-title, .item-after, .item-subtitle, item-header, .item-text"
        >
        </f7-searchbar>
    </f7-navbar>
    <AppLayout>
          <template #main>
                    <f7-list
          dividers
          strong-ios
          transaction-list
          class="searchbar-not-found"
          v-if="!notificationList"
        >
          <f7-list-item :title="$t('common.nothingFound')"> </f7-list-item>
        </f7-list>
        <f7-list
          v-else
          media-list
          strong-ios
          class="notifications-list searchbar-found"
        >
          <f7-list-item
            class="avocash-card card"
            :class="{ 'notification-item--unread': isUnread(item) }"
            swipeout
            v-for="(item, index) in (notificationList || []).filter(
              (n) => !profile?.sub || !n.has_deleted || !n.has_deleted.includes(profile.sub)
            )"
            :key="index"
            :title="item.title"
            :subtitle="item.senderName"
            :text="item.body"
            :after="$dayjs(new Date(item.sent_time)).format('HH:mm')"
            @click="readNotification(item.id)"
          >
            <template #media>
              <img
                v-if="item.senderId"
                :src="'https://cdn.avocash.com/' + item.senderId + '/avatar.jpeg'"
                :alt="$t('common.a11y.userAvatar')"
                class="notification-avatar"
              />
              <f7-badge
                v-else
                class="notification-initials"
              >{{ $filtersGetInitial.getInitial(item.senderName) }}</f7-badge>
            </template>
            <f7-swipeout-actions right>
              <f7-swipeout-button
                v-if="item.link"
                close
                class="swipeout-more"
                @click="goToLink(item.link)"
              >{{ $t("common.more") }}</f7-swipeout-button>
              <f7-swipeout-button
                @click="deleteNotification(item.id)"
                close
                overswipe
                class="swipeout-delete"
                :confirm-text="$t('common.deleteNotificationConfirm')"
              >{{ $t("common.delete") }}</f7-swipeout-button>
            </f7-swipeout-actions>
            <f7-swipeout-actions left>
              <f7-swipeout-button
                v-if="isUnread(item)"
                close
                overswipe
                class="swipeout-read"
                @click="readNotification(item.id)"
              >{{ $t("common.markAsRead") }}</f7-swipeout-button>
            </f7-swipeout-actions>
            <template #footer>
              <img
                v-if="item.attachments && item.attachments.length > 0"
                :src="item.attachments[0].url"
                :alt="$t('common.a11y.attachment')"
                class="notification-attachment"
              />
            </template>
          </f7-list-item>
        </f7-list>
      </template>
        </AppLayout>
  </f7-page>
</template>

<style scoped>
.notification-avatar {
  height: 44px;
  width: 44px;
  border-radius: 50%;
  object-fit: cover;
}

.notification-initials {
  height: 44px;
  width: 44px;
  font-size: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--avocash-green, #1A6B42);
  color: #fff;
  font-weight: 600;
  line-height: 1;
}

.notification-attachment {
  height: 44px;
  width: auto;
  border-radius: 6px;
  object-fit: cover;
}

.notification-item--unread {
  border-left: 3px solid var(--avocash-green, #1A6B42);
  background-color: var(--avocash-green-light, #EAF2EB) !important;
}

.notification-item--unread :deep(.item-title) {
  font-weight: 600;
  color: var(--avocash-pit, #1C1C1E);
}

.notification-item--unread :deep(.item-subtitle) {
  font-weight: 500;
}

.notification-item--unread :deep(.item-after) {
  color: var(--avocash-green, #1A6B42);
  font-weight: 600;
}

:deep(.item-after) {
  color: var(--avocash-leaf, #5F8A4A);
  font-size: 13px;
}

:deep(.swipeout-more) {
  background: var(--avocash-blue, #3B4FCA);
}

:deep(.swipeout-delete) {
  background: var(--avocash-terracotta, #C0440A);
}

:deep(.swipeout-read) {
  background: var(--avocash-green, #1A6B42);
}

.searchbar-notifications :deep(input) {
  border-color: var(--avocash-leaf, #5F8A4A);
}

.searchbar-notifications :deep(input:focus) {
  border-color: var(--avocash-green, #1A6B42);
}

.searchbar-not-found :deep(.item-title) {
  color: var(--avocash-leaf, #5F8A4A);
  font-style: italic;
}
</style>

<script setup>
import { ref, computed, onMounted } from "vue";
import { f7 } from "framework7-vue";
import AppLayout from "@/components/common/AppLayout.vue";
import { useTabletScreen } from "../js/composables/useMediaQuery.js";
import { useNotificationStore } from "../js/pinia-stores/notification.js";
import { useMessageStore } from "../js/pinia-stores/message.js";
import { useAccountStore } from "../js/pinia-stores/account.js";
import { useAuthStore } from "../js/pinia-stores/auth.js";
import navbarright from "../components/navbarright.vue";
import { useWebSocket } from "../js/composables/useWebSocket.js";
import _ from "lodash";

const props = defineProps({
  f7route: Object,
  f7router: Object,
});

const allowInfinite = ref(true);
const showPreloader = ref(false);
const visibleItem = ref(60);
const notificationStore = useNotificationStore();
const messageStore = useMessageStore();
const accountStore = useAccountStore();
const authStore = useAuthStore();

const isTablet = useTabletScreen().matches;
const notificationList=computed(() => notificationStore.notificationList);
const newNotifList = computed(() => notificationStore.newNotifList);
const messageSocketClient = computed(() => messageStore.messageSocketClient);
const msgCltConnected = computed(() => messageStore.msgCltConnected);
const userAccount = computed(() => accountStore.userAccount);
const userDetail = computed(() => accountStore.userDetail);
const searchedUser = computed(() => accountStore.searchedUser);
const phoneNumberDetail = computed(() => authStore.phoneNumberDetail);
const mobilePhoneError = computed(() => authStore.mobilePhoneError);
const profile = computed(() => authStore.profile);

const { connectMessageSocket } = useWebSocket({ f7router: props.f7router });

onMounted(() => {
  if (!msgCltConnected.value) {
    connectMessageSocket();
  }
  if (!notificationList.value || notificationList.value === "") {
    notificationStore.getNotificationList({
      limit: visibleItem.value,
      skip: notificationList.value.length,
    });
  }
});

function isUnread(item) {
  return !item.has_read.includes(profile?.value?.sub);
}

function deleteNotification(notificationId) {
  f7.preloader.show("multi");
  setTimeout(() => {
    console.log(notificationId);
    notificationList.value.splice(
      notificationList.value.findIndex((n) => n.id === notificationId),
      1
    );
    f7.preloader.hide();
  }, 1000);
  f7.preloader.hide();
}

function readNotification(notificationId) {
  f7.preloader.show("multi");
  setTimeout(() => {
    notificationStore.readNotification(notificationId);
    notificationList.value.splice(
      notificationList.value.findIndex((n) => n.id === notificationId),
      1,
      {
        ...notificationList.value.find((n) => n.id === notificationId),
        has_read: [
          ...notificationList.value.find((n) => n.id === notificationId).has_read,
          profile?.value?.sub,
        ],
      }
    );

    f7.preloader.hide();
  }, 1000);
  f7.preloader.hide();
}

function goToLink(link) {
  props.f7router.navigate(link);
}

function loadMore(done) {
  setTimeout(() => {
    if (notificationList.value && notificationList.value.length === 0) {
      showPreloader.value = false;
      return;
    }
    showPreloader.value = true;
    const itemsLength = notificationList.value.length;
    notificationStore.getNotificationList({
      limit: visibleItem.value,
      skip: itemsLength,
    });
    done();
  }, 1000);
}

function loadMoreScroll() {
  if (!allowInfinite.value) return;
  allowInfinite.value = false;
  const loadMoreThreshold = 30;
  setTimeout(() => {
    if (newNotifList.value && newNotifList.value.length == 0) {
      return;
    }
    const itemsLength = notificationList.value.length;
    visibleItem.value += loadMoreThreshold;
    notificationStore.getNotificationList({
      limit: visibleItem.value,
      skip: itemsLength,
    });
    allowInfinite.value = true;
  }, 1000);
}

function pageInit() {
  if (notificationList.value === "") {
    notificationStore.getNotificationList({
      limit: visibleItem.value,
      skip: notificationList.value.length,
    });
  }
}
</script>
